import { render, staticRenderFns } from "./MyChecklists.vue?vue&type=template&id=585f35d7&scoped=true&"
import script from "./MyChecklists.vue?vue&type=script&lang=js&"
export * from "./MyChecklists.vue?vue&type=script&lang=js&"
import style0 from "./MyChecklists.vue?vue&type=style&index=0&id=585f35d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585f35d7",
  null
  
)

export default component.exports